import React from 'react';
import { Page as Component } from '~/components/specifics/deals/[id]/Page';

export const Page: React.FC = () => <Component />;
